import React, { useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { FaDownload, FaShareAlt } from 'react-icons/fa';
import './App.css';
import axios from 'axios';

const App = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    personalEmail: '',
    officeEmail: '',
    companyAddress: 'No 3, PTL Towers, Ajao Road, Ikeja Lagos',
    companyName: 'Sabre Central and West Africa',
    website: 'sabrecwa.com',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const generateVCard = () => {
    return `BEGIN:VCARD\nVERSION:3.0\nN:${formData.lastName};${formData.firstName}\nFN:${formData.firstName} ${formData.lastName}\nTEL;TYPE=CELL:${formData.phone}\nEMAIL;TYPE=HOME:${formData.personalEmail}\nEMAIL;TYPE=WORK:${formData.officeEmail}\nADR;TYPE=WORK:${formData.companyAddress}\nORG:${formData.companyName}\nURL:${formData.website}\nEND:VCARD`;
  };

  const downloadQRCode = () => {
    const canvas = document.getElementById('qrcode');
    const pngUrl = canvas.toDataURL('image/png');
    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = 'vcard-qrcode.png';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('http://localhost:5000/api/vcards', formData);
      console.log('Data submitted successfully:', response.data);
      alert('VCard data submitted successfully!');
    } catch (error) {
      console.error('Error submitting data:', error);
      alert('Failed to submit VCard data.');
    }
  };

  return (
    <div className="container">
      <h1>Account Details</h1>
      <div className="form-section">
        <form onSubmit={handleSubmit}>
          {[
            { name: 'firstName', placeholder: 'First Name' },
            { name: 'lastName', placeholder: 'Last Name' },
            { name: 'phone', placeholder: 'Phone Number' },
            { name: 'personalEmail', placeholder: 'Personal Email' },
            { name: 'officeEmail', placeholder: 'Office Email' },
            { name: 'companyAddress', placeholder: 'Company Address' },
            { name: 'companyName', placeholder: 'Company Name' },
            { name: 'website', placeholder: 'Website' },
          ].map((field) => (
            <input
              key={field.name}
              name={field.name}
              type="text"
              value={formData[field.name]}
              onChange={handleChange}
              placeholder={field.placeholder}
            />
          ))}
          <button type="button" onClick={() => setFormData({ ...formData })}>
            Generate QR Code
          </button>
        </form>

        {formData.firstName && (
          <div className="qr-section">
            <div className="qr-container">
              <div className="action-buttons">
                <button onClick={downloadQRCode}>
                  <FaDownload />
                </button>
                <button
                  className="share"
                  onClick={() =>
                    navigator.share({
                      title: 'VCard QR Code',
                      url: window.location.href,
                    })
                  }
                >
                  <FaShareAlt />
                </button>
              </div>
              <QRCodeCanvas
                id="qrcode"
                value={generateVCard()}
                size={200}
                level={'H'}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default App;